import { connect } from 'react-redux';
import DepositStatusModalComponent from './DepositConfirmationModalComponent';
import modalDecorator from '../../hocs/modalDecorator';
import { MODAL_TYPES, openModal as _openModal } from '../../redux/actions/modalActions';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal() {
      return dispatch(_openModal(MODAL_TYPES.DEPOSIT_STATUS));
    }
  };
};
var container = connect(null, mapDispatchToProps)(DepositStatusModalComponent);
export default modalDecorator({
  name: MODAL_TYPES.DEPOSIT_STATUS
})(container);